import serviceHistory from "../shared/services/serviceHistoryService";

const REQUEST_SERVICE_HISTORY = "REQUEST_SERVICE_HISTORY";
const RESPONSE_SERVICE_HISTORY = "RESPONSE_SERVICE_HISTORY";
const REQUEST_SERVICE_HISTORY_FAILURE = "REQUEST_SERVICE_HISTORY_FAILURE";

const requestServiceHistoryAction = () => {
  return {
    type: REQUEST_SERVICE_HISTORY,
  };
};

const responseServiceHistoryAction = (data) => {
  return {
    type: RESPONSE_SERVICE_HISTORY,
    data,
  };
};

const requestServiceHistoryFailureAction = (errors) => {
  return {
    type: REQUEST_SERVICE_HISTORY_FAILURE,
    errors,
  };
};

const getServiceHistory = (options) => {
  return (dispatch) => {
    dispatch(requestServiceHistoryAction());

    serviceHistory
      .getServiceHistory(options)
      .then((result) => {
        dispatch(responseServiceHistoryAction(result.data));
      })
      .catch((error) => {
        dispatch(requestServiceHistoryFailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY = "REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY";
const RESPONSE_CREATE_SERVICE_HISTORY_COMMENTARY = "RESPONSE_CREATE_SERVICE_HISTORY_COMMENTARY";
const REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY_FAILURE = "REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY_FAILURE";

const requestCreateServiceHistoryCommentAction = () => {
  return {
    type: REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY,
  };
};

const responseCreateServiceHistoryCommentAction = (serviceHistoryId, data) => {
  return {
    type: RESPONSE_CREATE_SERVICE_HISTORY_COMMENTARY,
    serviceHistoryId,
    data,
  };
};

const requestCreateServiceHistoryCommentFailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY_FAILURE,
    errors,
  };
};

const createServiceHistoryComment = (id, options) => {
  return (dispatch) => {
    dispatch(requestCreateServiceHistoryCommentAction());

    serviceHistory
      .createServiceHistoryComment(id, options)
      .then((result) => {
        dispatch(responseCreateServiceHistoryCommentAction(id, result.data));
      })
      .catch((error) => {
        dispatch(requestCreateServiceHistoryCommentFailureAction(error.response));
      });
  };
};

const REQUEST_SERVICE_HISTORY_ACTIONS = "REQUEST_SERVICE_HISTORY_ACTIONS";
const RESPONSE_SERVICE_HISTORY_ACTIONS = "RESPONSE_SERVICE_HISTORY_ACTIONS";
const REQUEST_SERVICE_HISTORY_ACTIONS_FAILURE = "REQUEST_SERVICE_HISTORY_ACTIONS_FAILURE";

const requestServiceHistoryActionsAction = () => {
  return {
    type: REQUEST_SERVICE_HISTORY_ACTIONS,
  };
};

const responseServiceHistoryActionsAction = (data) => {
  return {
    type: RESPONSE_SERVICE_HISTORY_ACTIONS,
    data,
  };
};

const requestServiceHistoryActionsFailureAction = (errors) => {
  return {
    type: REQUEST_SERVICE_HISTORY_ACTIONS_FAILURE,
    errors,
  };
};

const getServiceHistoryActions = () => {
  return (dispatch) => {
    dispatch(requestServiceHistoryActionsAction());

    serviceHistory
      .getServiceHistoryActions()
      .then((result) => {
        dispatch(responseServiceHistoryActionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestServiceHistoryActionsFailureAction(error.response));
      });
  };
};

export {
  REQUEST_SERVICE_HISTORY,
  RESPONSE_SERVICE_HISTORY,
  REQUEST_SERVICE_HISTORY_FAILURE,
  requestServiceHistoryAction,
  responseServiceHistoryAction,
  requestServiceHistoryFailureAction,
  getServiceHistory,
  REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY,
  RESPONSE_CREATE_SERVICE_HISTORY_COMMENTARY,
  REQUEST_CREATE_SERVICE_HISTORY_COMMENTARY_FAILURE,
  requestCreateServiceHistoryCommentAction,
  responseCreateServiceHistoryCommentAction,
  requestCreateServiceHistoryCommentFailureAction,
  createServiceHistoryComment,
  REQUEST_SERVICE_HISTORY_ACTIONS,
  RESPONSE_SERVICE_HISTORY_ACTIONS,
  REQUEST_SERVICE_HISTORY_ACTIONS_FAILURE,
  getServiceHistoryActions,
};
